export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_all-17fd79070eed63551dd539d71c1b7e1f.webp";